<template>
  <div>
    <div class="cropper-content">
      <div class="cropper">
        <vueCropper ref="cropper" :img="option.img" :outputSize="option.size" :outputType="option.outputType" :info="true" :full="option.full" :canMove="option.canMove" :canMoveBox="option.canMoveBox" :original="option.original" :autoCrop="option.autoCrop" :autoCropWidth="option.autoCropWidth" :autoCropHeight="option.autoCropHeight" :fixedBox="option.fixedBox" @realTime="realTime" @imgLoad="imgLoad">
        </vueCropper>
      </div>
      <div class="show-preview" :style="{'width': previews.w + 'px', 'height': previews.h + 'px',  'overflow': 'hidden', 'margin': '5px'}">
        <div :style="previews.div" class="preview">
          <img :src="previews.url" :style="previews.img">
        </div>
      </div>
    </div>
    <div class="footer-btn">
      <div class="scope-btn">
        <label class="btn" for="uploads">更换图片</label>
        <input type="file" id="uploads" style="position:absolute; clip:rect(0 0 0 0);" accept="image/png, image/jpeg, image/gif, image/jpg" @change="uploadImg($event, 1)">
        <button @click="changeScale(1)"><i class="el-icon-zoom-in"></i></button>
        <button @click="changeScale(-1)"><i class="el-icon-zoom-out"></i></button>
        <button @click="rotateLeft"><i class="el-icon-refresh-left"></i></button>
        <button @click="rotateRight"><i class="el-icon-refresh-right"></i></button>
      </div>
      <div class="upload-btn">
        <wf-button type="primary" :disabled="!option.img" :loading="uploading" @click="upload">上传<i class="el-icon-upload el-icon--right"></i></wf-button>
      </div>
    </div>
  </div>
</template>

<script>
import Api from "@/services/api/mySetting/mySetting.js"
import axios from 'axios'
import uploadApi from '@/services/api/upload/upload'
export default {
  name: "AvatarCropper",
  props: {
    avatarUrl: {
      type: String,
      default: ''
    },
    phone: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      crap: false,
      previews: {},
      option: {
        img: "",
        size: 1,
        full: false,
        outputType: 'png',
        canMove: true,
        original: false,
        canMoveBox: true,
        autoCrop: true,
        autoCropWidth: 150,
        autoCropHeight: 150,
        fixedBox: true
      },
      downImg: '#',
      file: null,
      uploading: false
    }
  },
  methods: {
    changeScale(num) {
      num = num || 1
      this.$refs.cropper.changeScale(num)
    },
    rotateLeft() {
      this.$refs.cropper.rotateLeft()
    },
    rotateRight() {
      this.$refs.cropper.rotateRight()
    },
    // 实时预览函数
    realTime(data) {
      this.previews = data
    },
    down(type) {
      var aLink = document.createElement('a')
      aLink.download = 'author-img'
      if (type === 'blob') {
        this.$refs.cropper.getCropBlob((data) => {
          this.downImg = window.URL.createObjectURL(data)
          aLink.download = this.downImg;
          aLink.href = window.URL.createObjectURL(data)
          aLink.click()
        })
      } else {
        this.$refs.cropper.getCropData((data) => {
          this.downImg = data
          aLink.href = data
          aLink.click()
        })
      }
    },
    uploadImg(e, num) {

      //上传图片
      this.option.img
      var file = e.target.files[0]
      if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
        alert('图片类型必须是.gif,jpeg,jpg,png,bmp中的一种')
        return false
      }
      var reader = new FileReader()
      reader.onload = (e) => {
        let data = null;
        if (typeof e.target.result === 'object') {
          // 把Array Buffer转化为blob 如果是base64不需要
          data = window.URL.createObjectURL(new Blob([e.target.result]))
        } else {
          data = e.target.result
        }
        if (num === 1) {
          this.option.img = data
        }
      }
      // 转化为base64  reader.readAsDataURL(file)
      // 转化为blob
      reader.readAsArrayBuffer(file)
    },
    dataURLtoFile(dataurl, filename) {
      let arr = dataurl.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let bstr = atob(arr[1])
      let len = bstr.length
      let u8arr = new Uint8Array(len)
      while (len--) {
        u8arr[len] = bstr.charCodeAt(len)
      }
      return new File([u8arr], filename, { type: mime })
    },
    imgLoad(msg) {
    },
    async upload() {
      // 直接上传到服务器吧
      // var formData = new FormData();
      // this.uploading = true;
      // this.$refs.cropper.getCropData((data) => {
      //   formData.append("file", this.dataURLtoFile(data, "裁剪头像.jpg"))
      //   formData.append("type", "avatar")
      //   Api.uploadAvatar(formData).then(res => {
      //     let params = {
      //       uid: res.add_uid,
      //       user_avatar: {
      //         size: res.attachment_size,
      //         sign: res.attachment_sign,
      //         type: res.attachment_type
      //       }
      //     };
      //     Api.updateSelfInfoToAvatar(params).then(res => {
      //       this.uploading = false;
      //       this.$emit("uploadSuccess")
      //       this.$message({ message: "上传成功", type: "success" })
      //     }).catch(err => {
      //       this.$message({ message: "上传失败", type: "error" })
      //     })
      //   })
      // })
      this.uploading = true
      this.$refs.cropper.getCropData((data) => {
        let file = this.dataURLtoFile(data, "裁剪头像.jpg")
        this.uploadEmit(file)
      })

    },
    async uploadEmit(file) {
      const _data = {
        upload_type: 'ordinary',
        type: 'avatar',
        attachment_name: file.name
      }
      const res = await uploadApi.getPolicy(_data)
      if (res) {
        let dataset = new FormData()
        dataset.append('name', res.oss_attachment_name)
        dataset.append('key', res.dir + res.oss_attachment_name)
        dataset.append('policy', res.policy)
        dataset.append('OSSAccessKeyId', res.accessid)
        dataset.append('success_action_status', '200')
        dataset.append('callback', res.callback)
        dataset.append('Content-Disposition', `attachment; filename="${file.name}"`)
        dataset.append('x-oss-object-acl', `public-read`)
        dataset.append('signature', res.signature)
        dataset.append('file', file.raw || file)
        axios.defaults.withCredentials = false
        axios.defaults.crossDomain = true
        let httpDefaultOpts = {
          baseURL: '',
          method: 'post',
          cache: false,
          url: process.env.NODE_ENV === 'development' ? 'airworthiness_certified' : res.host,
          timeout: 0,
          data: dataset,
          headers: { 'Content-Type': 'multipart/form-data', 'Accept': '*/*' }
        }
        let result = await axios(httpDefaultOpts)
        console.log(result)
        let params = {
          uid: result.data.data.add_uid,
          user_avatar: {
            size: result.data.data.attachment_size,
            sign: result.data.data.attachment_sign,
            type: result.data.data.attachment_type
          }
        };
        await Api.updateSelfInfoToAvatar(params)
        this.uploading = false
        this.$emit("uploadSuccess")
      }
    },
    initAvatar() {
        let _this = this
         this.getBase64Img(this.avatarUrl,(url) => {
          _this.option.img = url
        });
    }
  },
  watch: {
    avatarUrl: {
      handler: function (newVal) {
        this.initAvatar()
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.cropper-content {
  display: flex;
  display: -webkit-flex;
  justify-content: flex-end;
  -webkit-justify-content: flex-end;
  .cropper {
    width: 350px;
    height: 300px;
  }
  .show-preview {
    flex: 1;
    -webkit-flex: 1;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    -webkit-justify-content: center;
    .preview {
      overflow: hidden;
      border-radius: 50%;
      border: 1px solid #cccccc;
      background: #cccccc;
    }
  }
}
.footer-btn {
  margin: 32px 0;
  display: flex;
  display: -webkit-flex;
  justify-content: flex-end;
  -webkit-justify-content: flex-end;
  .scope-btn {
    width: 350px;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    -webkit-justify-content: space-between;
  }
  .upload-btn {
    flex: 1;
    -webkit-flex: 1;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    -webkit-justify-content: center;
    button {
      font-size: 14px;
    }
  }
  .btn {
    outline: none;
    display: inline-block;
    line-height: 1.3;
    white-space: nowrap;
    cursor: pointer;
    -webkit-appearance: none;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    outline: 0;
    margin: 0;
    -webkit-transition: 0.1s;
    transition: 0.1s;
    font-weight: 500;
    padding: 8px 15px;
    font-size: 12px;
    border-radius: 3px;
    color: #fff;
    background: linear-gradient(225deg,#269af9,#0f73e9);
    border-color: linear-gradient(225deg,#269af9,#0f73e9);
  }
  button {
    cursor: pointer;
    border: none;
    font-size: 18px;
    background: #fff;
    border: 1px solid #e7e8ed;
  }
}
</style>

